import React, { useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';

const ReportDestinyPrint = React.forwardRef(({ members, selectedDestiny }, ref) => {
    return (
        <div ref={ref} className="hidden print:block m-8">
            <h1 className="text-2xl font-bold mb-4">Relatório de Participantes - {selectedDestiny.label}</h1>
            <table className="w-full border-collapse">
                <thead>
                    <tr className="">
                        <th className="py-2 px-1 text-left text-xs font-normal uppercase">Nome</th>
                        <th className="py-2 px-1 text-left text-xs text-center font-normal uppercase">Nascimento</th>
                        <th className="py-2 px-1 text-left text-xs text-center font-normal uppercase">Passaporte</th>
                        <th className="py-2 px-1 text-left text-xs text-center font-normal uppercase">Situação</th>
                    </tr>
                </thead>
                <tbody>
                    {members.map((member, index) => (
                        <tr key={index} className="border-b border-gray-300">
                            <td className="py-2 px-1 text-[10px] uppercase whitespace-nowrap">{member.nome_completo}</td>
                            <td className="py-2 px-1 text-[10px] text-center">{member.data_nascimento}</td>
                            <td className="py-2 px-1 text-[10px] text-center">{member.numero_passaporte}</td>
                            <td className="py-2 px-1">
                                {member.situacao ? (
                                    <FontAwesomeIcon icon={faCheck} className="mr-2 text-xl text-green-500" />
                                ) : (
                                    <FontAwesomeIcon icon={faXmark} className="mr-2 text-xl text-red-500" />
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
});

export default ReportDestinyPrint;